import { FAQ, faqData } from '@/components/FAQ';
import { SEOMeta } from '@/templates/SEOMeta';
import {getI18nProps} from "@/utils/i18n";
import { generateFAQPageSchema } from '@/utils/schema';

export async function getStaticProps(ctx) {
  const { getI18nPropsWithSeo } = await import('@/utils/i18n');
  return getI18nPropsWithSeo(ctx, 'faq', '/faq');
}

export default function PageFAQ({ seoMeta }) {
  const allFaqs = [...faqData.partners, ...faqData.affiliates];

  return (
      <>
          <SEOMeta
              title="Afivio FAQ | Affiliate Program, Tracking, Payouts, and Integrations"
              description="Answers about Afivio pricing, affiliate tracking, referral links, payouts, Shopify, Stripe, Horoshop, and affiliate program setup."
              keywords="afivio faq, affiliate marketing software faq, affiliate tracking questions, referral program setup, affiliate payouts, shopify affiliate app faq"
              url={seoMeta?.url || "/faq"}
              structuredData={generateFAQPageSchema(allFaqs)}
          />
          <FAQ />
      </>
  );
}
